import { render, staticRenderFns } from "./InventoryByBoxCard.vue?vue&type=template&id=9e316fde&"
import script from "./InventoryByBoxCard.vue?vue&type=script&lang=js&"
export * from "./InventoryByBoxCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryByBoxCard.vue?vue&type=style&index=0&id=9e316fde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports